import { render } from "./DefaultHeaderComponent.vue?vue&type=template&id=3b6e6d84&ts=true"
import script from "./DefaultHeaderComponent.vue?vue&type=script&lang=ts"
export * from "./DefaultHeaderComponent.vue?vue&type=script&lang=ts"

import exportComponent from "D:\\victo\\Documents\\Projects\\RawData\\product-web\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__